import { FormEvent } from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import removeAllErrorMsg from "../../../components/funcRemoveAllErros"
import { toast } from "react-toastify"

export default function ModalDocumentoRenomear({ show, handleClose, handleRenomear, documento }:iProps) {
    function handleSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault()
        event.stopPropagation()
    
        removeAllErrorMsg()

        const form:any = event.target
        let formValidado = true

        let dados = {
            codigo: documento.codigo,
            nome: form.nome.value,
        }

        if (dados.nome === "") {
            toast.error('Informe o novo nome!', {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            form.nome.nextElementSibling.style.display = "block"
            formValidado = false
            return
        }

        const nome:string = dados.nome
        if (nome.search(".pdf") < 0) {
            toast.error(`Escreva: ".pdf", no final do nome!`, {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
            formValidado = false
            return
        }

        console.log(dados)
        if (!formValidado) {
            return
        }

        handleRenomear(dados)
    }

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title><b>Renomear Documento</b></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id={`formRenomearDocumento`} onSubmit={handleSubmit} noValidate>
                    <Row>
                        <Col className="col-12">
                            <Form.Group>
                                <Form.Label>Nome:</Form.Label>
                                <Form.Control type="text" name="nome" id="nome" defaultValue={documento.nome} required />
                                <Form.Control.Feedback type="invalid">
                                    Informe o novo nome!
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br/>
                    <Button type="submit" variant="success">Salvar</Button>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    )
}
interface iProps {
    show: boolean
    handleClose: any
    handleRenomear: any
    documento: any
}
